import ContentPageMenu from './Menu';

export default ContentPageMenu;

// TODO:Loadable has been removed to display components on the SSR side, this is a temporary solution agreed with Ivan Postol, in the future need to use the standard solutions provided by React 18 instead of the library '@loadable/component'
